import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {pluralizeWord} from '~/common/utils';
import {Typography} from '~library/atoms/Typography';
import {GroundhogModal} from '../../common/Modal/GroundhogModal';
import {GiftingModule} from './GiftingModule';
import {RegistryModule} from './RegistryModule';

/*
 * Modal that pops up when the guest views the invitation the first time after rsvping
 * Can be paused for 1 year by hitting the "Don’t Show Again" button,
 * or for 1 day by hitting the "Remind me later" button
 */

export const GiftingModal = (props) => {
  const {giftingType} = props;
  const [isOpen, setIsOpen] = useState(false);
  const isHost = useSelector((s) => s.user.isHost);
  const hasRsvpd = useSelector((s) => s.rsvp.hasRsvpd);
  const registries = useSelector((state) => state.registry?.registries) || [];

  const registryName = useSelector((state) => state.registry?.name ?? '');
  const giftRegistryType = useSelector(
    (state) => state.registry?.gift_registry_type ?? state.registry?.registry_type
  );
  const isWishlist = giftRegistryType === 'wishlist';
  const registryType = isWishlist ? 'wishlist' : 'registry';
  let moduleTitle = registryType === 'wishlist' ? 'Wishlist' : 'Gift Registry';
  if (registryName) {
    moduleTitle = `${registryName}'s ${pluralizeWord(registryType, registries.length)}`;
  }

  window.experimentsEligibility = window.experimentsEligibility || {};
  window.experimentsEligibility['gifting-modal'] = hasRsvpd && !isHost ? 'true' : false;

  // biome-ignore lint/correctness/useExhaustiveDependencies: deps
  useEffect(() => {
    if (hasRsvpd && !isHost)
      // Delay the modal popup so the page has time to render before animating it in.
      window.setTimeout(() => {
        setIsOpen(true);
      }, 300);
  }, [hasRsvpd, isHost, giftingType]);

  return (
    <GroundhogModal
      isOpen={isOpen}
      hideModal={() => setIsOpen(false)}
      showDontShowAgain
      showRemindMeLater
      cookieName="giftingPrompt"
    >
      <div className="gifting-modal">
        <Typography variant="header2" as="p">
          <ToastModalHeading />
        </Typography>
        {giftingType === 'registry' && (
          <>
            <Typography variant="paragraph2" classNames="gifting-modal__registry-name">
              {moduleTitle}
            </Typography>
            <RegistryModule showHeader={false} locationPrefix="toast" inModal />
          </>
        )}
        {giftingType === 'gifting' && <RenderGifting />}
      </div>
    </GroundhogModal>
  );
};

const ToastModalHeading = () => 'Looking for gift ideas?';

const RenderGifting = () => (
  <GiftingModule
    showHeader={false}
    vendorDiscDataQaId="af-invite-toast"
    isBottomSheet
    showGiftKeywords={false}
  />
);
